/**
 * Nine anchor positions shared by watermark placement and crop origin.
 * Reading order matches both grids. Each control keeps its own labels, copy, and layout.
 */
export const WORKSPACE_AGENT_ANCHOR_POSITIONS = [
  'top-left',
  'top-center',
  'top-right',
  'middle-left',
  'center',
  'middle-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
] as const;

export type WorkspaceAgentAnchorPosition = (typeof WORKSPACE_AGENT_ANCHOR_POSITIONS)[number];

export const isWorkspaceAgentAnchorPosition = (value: string): value is WorkspaceAgentAnchorPosition =>
  WORKSPACE_AGENT_ANCHOR_POSITIONS.some((position) => position === value);
